import React, { useEffect, useState } from 'react';
import capitalize from 'lodash/capitalize';
import { Notification } from '@progress/kendo-react-notification';
import useTimer from '../../hooks/useTimer';
import { parseError } from 'shared/../helpers/errorParser';

const expiryDict = {
  success: 5000,
  error: null,
  default: 7000,
};

const getMainContent = (toast) => {
  const {
    type, message, verb = 'save', name,
  } = toast;
  if (message) {
    return message;
  }
  const fName = name ? name.split(' ').map(capitalize).join(' ') : '';
  const fVerb = verb?.toLowerCase() ?? '';
  switch (type) {
  case 'error':
    return `Failed to ${fVerb} ${fName}`;
  case 'success':
    return `${fName} ${fVerb === 'delete' ? 'deleted' : 'saved'} successfully`;
  default:
    return `${fName} ${fVerb}`;
  }
};

const Toast = ({ dataItem, onClose, ...props }) => {
  const { type, error } = dataItem;

  // if location changes, close self
  const [url, _] = useState(window.location.href);
  useEffect(() => {
    const newUrl = window.location.href;
    if (newUrl === url || dataItem.type !== 'error') {
      return;
    }
    onClose();
  }, [window.location.href]);

  // timer
  const doExpire = expiryDict[type] !== null;

  let { reset, start } = useTimer({
    expiry: expiryDict[type] ?? expiryDict.default,
    onExpire: onClose,
    autoStart: doExpire,
  });

  reset = doExpire ? reset : () => {};
  start = doExpire ? start : () => {};

  return (
    <Notification
      type={{ style: type, icon: true }}
      closable
      onClose={onClose}
      className='k-item'
      {...props}
    >
      <div className='toast-item' onMouseEnter={reset} onMouseLeave={start}>
        <div className='toast-item-main'>
          {getMainContent(dataItem)}
        </div>
        {type === 'error' && error && (
          <div className='toast-item-sub'>
            {parseError(error)}
          </div>
        )}
      </div>
    </Notification>
  );
};

export default Toast;
